export const pixKeyOptions = [
  { value: 'CPF/CNPJ', label: 'CPF/CNPJ' },
  { value: 'E-mail', label: 'E-mail' },
  { value: 'Telefone', label: 'Telefone' },
  { value: 'Chave aleatória', label: 'Chave aleatória' },
];